export default "__VITE_ASSET__CVnzXPi$__"